import { useMemo } from 'react'
import _ from 'lodash'

const getRandomString = length => _.times(length, () => _.random(35).toString(36)).join('')

export const useId = (prefix = '', length = 10) => useMemo(() => prefix + getRandomString(length), [prefix, length])
